// extracted by mini-css-extract-plugin
export default {"InputButton":"select-target-dialog_InputButton__qoN9F"};